import type { FC } from "react";

import type { UserTutoringAssignmentMinimumFragment } from "api/generated";
import VideoIcon from "images/icons/youtube.svg";

interface Props {
  activeId?: string;
  fixedAssignments?: UserTutoringAssignmentMinimumFragment[];
  trainingAssignments?: UserTutoringAssignmentMinimumFragment[];
}

export const TutoringProgressBar: FC<Props> = ({ activeId, fixedAssignments, trainingAssignments }) => {
  const assignmentsCount = (fixedAssignments?.length ?? 0) + (trainingAssignments?.length ?? 0);

  return (
    <div className="tutoring-bar">
      <div className="tutoring-bar__item">
        <div
          className={`tutoring-bar__assignment ${
            activeId === undefined ? "tutoring-bar__assignment--active" : "tutoring-bar__assignment--finished"
          }`}
        />
        <div className="tutoring-bar__video-icon align-self-center">
          <VideoIcon />
        </div>
      </div>

      {fixedAssignments?.length ? (
        <div
          className="tutoring-bar__item"
          style={{
            flexGrow: Math.round((fixedAssignments.length / assignmentsCount) * 100),
            maxWidth: fixedAssignments.length * 15 + 7.5, // 15px per item + 7.5px padding
          }}
        >
          <div className="tutoring-bar__assignments-wrapper">
            {fixedAssignments.map(item => {
              const itemId = item.userAssignmentObject?.id;
              if (!itemId) return null;

              return (
                <div
                  key={itemId}
                  className={`tutoring-bar__assignment ${item.finished ? "tutoring-bar__assignment--finished" : ""} ${
                    activeId === itemId ? "tutoring-bar__assignment--active" : ""
                  }`}
                />
              );
            })}
          </div>
          <div className="text-uppercase">Doučko</div>
        </div>
      ) : null}

      {trainingAssignments?.length ? (
        <div
          className="tutoring-bar__item"
          style={{
            flexGrow: Math.round((trainingAssignments.length / assignmentsCount) * 100),
            maxWidth: trainingAssignments.length * 15 + 7.5, // 15px per item + 7.5px padding
          }}
        >
          <div className="tutoring-bar__assignments-wrapper">
            {trainingAssignments.map(item => {
              const itemId = item.userAssignmentObject?.id;
              if (!itemId) return null;

              return (
                <div
                  key={itemId}
                  className={`tutoring-bar__assignment ${item.finished ? "tutoring-bar__assignment--finished" : ""}
                  ${activeId === itemId ? "tutoring-bar__assignment--active" : ""}`}
                />
              );
            })}
          </div>
          <div className="text-uppercase">Procvičování</div>
        </div>
      ) : null}
    </div>
  );
};
